import moment from 'moment';
import debugFactory from 'debug';

import { capitalize } from './string-utils';

const debug = debugFactory('date-utils');

const defaultDateShortFormat = 'DD/MM/YYYY';
const defaultDateLongFormat = 'DD MMMM YYYY';
const defaultDateTimeFormat = 'DD/MM/YYYY HH:mm:ss';
const defaultDateTimeLongFormat = 'DD/MM/YYYY [à] HH[h]mm';
const defaultMonthFormat = 'MMMM YYYY';


const formatDate = (date, format) => {
  if (!date || !(date instanceof Date || typeof date === 'string' || date instanceof String)) {
    return '';
  }
  const m = moment(date);
  if (!m.isValid()) {
    debug('Unable to format:', date);
    return '';
  }
  return m.format(format);
};

export const formatDateShort = (date, format) => formatDate(date, format || defaultDateShortFormat);
export const formatDateLong = (date, format) => formatDate(date, format || defaultDateLongFormat);
export const formatDateTime = (date, format) => formatDate(date, format || defaultDateTimeFormat);
export const formatDateTimeLong = (date, format) => formatDate(date, format || defaultDateTimeLongFormat);
export const formatMonth = (date, format) => capitalize(formatDate(date, format || defaultMonthFormat));



// WEBPACK FOOTER //
// ./shared/src/utils/date-utils.js